export const eventVersion = 1;

export const detectionStrategies = {
  waitForZeroOpenHTTPs: 'waitForZeroOpenHTTPs',
  waitForSelector: 'waitForSelector',
};

export const maxDuration = 20 * 1000;
export const zeroHTTPsCheckInterval = 100;
